import type * as React from 'react';

import { cn } from '@/shadcn/lib/utils';

function Textarea({ className, ...props }: React.ComponentProps<'textarea'>) {
  return (
    <textarea
      className={cn(
        'field-sizing-content flex min-h-16 w-full rounded-md border border-input bg-muted px-3 py-2 text-base shadow-xs outline-none outline-0 ring-offset-2 ring-offset-card transition-[color,box-shadow] placeholder:text-muted-foreground focus-visible:border-ring focus-visible:ring-2 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 aria-invalid:border-destructive aria-invalid:ring-destructive/20 md:text-sm dark:aria-invalid:ring-destructive/40',
        className
      )}
      data-slot="textarea"
      {...props}
    />
  );
}

export { Textarea };
